import { UserRole } from "../context/AuthContext";


export enum InviteStatus{
    pending = 'pending',
    accepted = 'accepted',
    rejected = 'rejected'
}
export interface UserInvite {
    id: string;  // Often useful to include the document ID if it's used in your app
    firstName: string;
    lastName: string;
    email: string;
    invitationBy: string;
    channelId?: string;
    channelName?: string;
    role:UserRole;
    status: InviteStatus
}